import { render } from "./FamilyPlanning.vue?vue&type=template&id=34c5dc85&scoped=true"
import script from "./FamilyPlanning.vue?vue&type=script&lang=js"
export * from "./FamilyPlanning.vue?vue&type=script&lang=js"

import "./FamilyPlanning.vue?vue&type=style&index=0&id=34c5dc85&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c5dc85"]])

export default __exports__